

































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Temp} from '@/models';

import CrudTempEditDialog from '@/components/Crud/Temp/EditDialog.vue';
import CrudTempList from '@/components/Crud/Temp/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import storeTemp, {TempFilter} from "@/stores/modules/temp";
import CrudTempAgenda from '@/components/Crud/Temp/Agenda.vue'

@Component({
	components: {
		CrudTempEditDialog,
		CrudTempList,
		CrudDeleteDialog,
		CrudTempAgenda,
	}
})
export default class TempView extends Vue {

	@Stored(() => storeTemp) private temps!: ResultType<Temp>;
	@Stored(() => storeTemp) private filters!: TempFilter;

	private imgPath: string = "";

	private editTemp: Temp = null;
	private deletedTemp: Temp = null;
	private storeTemp = storeTemp;
	private list;

	public mounted() {
		this.list = this.$refs['list'] as CrudTempList
	}

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editTemp = new Temp();
		this.refresh();
	}

	private refresh(): void {
		storeTemp.dispatch('getC', { filters: true });
	}
}
